import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatIconModule } from '@angular/material/icon';
import { InfoBubbleModule } from '@shared/info-bubble';

export const declarations = [ConfirmDialogComponent];

export const imports = [
  MatDialogModule,
  MatButtonModule,
  MatToolbarModule,
  MatIconModule,
  FlexLayoutModule,
  InfoBubbleModule,
];

@NgModule({
  declarations,
  imports: [CommonModule, RouterModule, TranslateModule.forChild(), ...imports],
  exports: declarations,
})
export class ConfirmDialogModule {}
